// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kiaJ","title":"Header_title__2BnRG","side":"Header_side__s2BvS"};